<template>
  <div
    ref="popup"
    class="p-1 bg-white text-primary border border-primary rounded"
    :class="{'d-none':!show}"
  >
    <div v-for="(featureText,index) in fetureInfos" :key="index">{{featureText}}</div>
    <br />
  </div>
</template>
<script>
import Overlay from "ol/Overlay";
import axios from "axios";

/**
 * Create an overlay to anchor the popup to the map.
 */
var overlay = new Overlay({
  positioning: "bottom-left",
  stopEvent: false,
});

export default {
  props: ["map"],
  mounted() {
    overlay.setElement(this.$refs.popup);
  },
  beforeDestroy() {
    overlay.setElement(null);
    if (this.map) {
      this.map.un(["pointermove"], this.showInfo);
    }
  },
  data() {
    return {
      show: false,
      fetureInfos: [],
    };
  },
  watch: {
    map(newValue, oldValue) {
      if (newValue !== null) {
        newValue.addOverlay(overlay);
        newValue.on(["pointermove"], this.showInfo, this);
      } else if (oldValue != null) {
        newValue.removeOverlay(overlay);
        oldValue.un(["pointermove"], this.showInfo);
      }
    },
  },
  methods: {
    showInfo(evt) {
      this.fetureInfos = [];
      let hoverHitAnyFeature = false;
      this.map.forEachFeatureAtPixel(evt.pixel, (feature) => {
        hoverHitAnyFeature = true;
        overlay.setPosition(evt.coordinate);
        if (!feature.get("features")) {
          this.fetureInfos.push(
            feature.get("name") + " (" + feature.get("soort") + ")"
          );
        } else if (feature.get("features").length <= 10) {
          feature.get("features").forEach((f) => {
            this.fetureInfos.push(f.get("name") + " (" + f.get("soort") + ")");
          });
        }
      });
      this.show = this.fetureInfos.length > 0;
      if (hoverHitAnyFeature) {
        document.body.style.cursor = "pointer";
      } else {
        document.body.style.cursor = "";
      }
    },
  },
};
</script>